import moment from 'moment'
// 列表搜索配置
export const SearchFiled = []

export const STATUS_MAP = {
  QUEUING: '排队中',
  EXECUTING: '执行中',
  FINISHED: '已完成',
  FAILED: '执行失败'
}

// 列表字段
export const COLUMNS = [
  {
    title: "计划单名称",
    dataIndex: "taskName",
    width: 240,
  },
  // {
  //   title: "状态",
  //   dataIndex: "status",
  //   width: 180,
  //   customRender: (text) => STATUS_MAP[text]
  // },
  {
    title: "创建人",
    dataIndex: "createUserName",
    width: 160,
    ellipsis: true,
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    width: 160,
    ellipsis: true,
    customRender: (text) => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''
  },
  {
    title: "操作",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 220,
    fixed: 'right'
  }
]

export const ImportType = {
  PLAN_ORDER: "PLAN_ORDER"
}

export const TEMPLATEURL = {
  PLAN_ORDER: '/unify/order/v2/warehouse_transport/plan_order/export',
}